// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__gFOB9","fileBtn":"File_fileBtn__3UMIk","closeBtn":"File_closeBtn__7vLVN","fileSelected":"File_fileSelected__2rK9g","disabled":"File_disabled__2Am8x"};